import { useEffect, useRef } from 'react';
import rootedLogo from '../../assets/rooted-logo.jpg';

export default function ReactiveFoxMark({
  amplitude = 0,
  size = 80,
  isActive = false,
  style = {},
}) {
  const outerRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    if (!outerRef.current || !glowRef.current) return;

    const scale = isActive ? 1 + amplitude * 0.1 : 1;
    const glowOpacity = isActive ? 0.2 + amplitude * 0.5 : 0;
    const glowSize = isActive ? 6 + amplitude * 20 : 0;

    outerRef.current.style.transform = `scale(${scale})`;

    // Glow lives on its own absolutely-positioned layer behind the image.
    // Putting drop-shadow on the image container produced a visible white
    // square on iOS because filter: drop-shadow doesn't respect the parent
    // border-radius the same way box-shadow does.
    glowRef.current.style.boxShadow = isActive
      ? `0 0 ${glowSize}px ${glowSize / 2}px rgba(166, 124, 58, ${glowOpacity})`
      : 'none';
  }, [amplitude, isActive]);

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        flexShrink: 0,
        ...style,
      }}
    >
      {/* Glow layer — sits behind the image, picks up box-shadow only. */}
      <div
        ref={glowRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: '50%',
          transition: 'box-shadow 0.1s ease',
          zIndex: 0,
        }}
      />

      {/* Image container — clipped circle, scales with amplitude. */}
      <div
        ref={outerRef}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          overflow: 'hidden',
          position: 'relative',
          zIndex: 1,
          transition: 'transform 0.08s ease',
          animation: !isActive ? 'fox-breathe 3s ease-in-out infinite' : 'none',
          willChange: 'transform',
          WebkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
        }}
      >
        <img
          src={rootedLogo}
          alt="Rooted"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      <style>{`
        @keyframes fox-breathe {
          0%, 100% { transform: scale(1); opacity: 0.85; }
          50% { transform: scale(1.04); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
